import { render } from "./lrbTable3.vue?vue&type=template&id=682ffe40&scoped=true"
import script from "./lrbTable3.vue?vue&type=script&lang=js"
export * from "./lrbTable3.vue?vue&type=script&lang=js"

import "./lrbTable3.vue?vue&type=style&index=0&id=682ffe40&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682ffe40"]])

export default __exports__